import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const SMS_ENDPOINTS = {
  V1: createEndpoints('v1', {
    SEND_BULK_SMS: '/services/send-bulk-sms',
  }),
} as const;
